import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { api } from "../api/api";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { format, set } from "date-fns";
import VehicleDescription from "../components/VehicleDescription";
import { FaPhone } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import Ratings from "../components/Ratings";
import BookingModal from "../components/BookingModal";
import Swal from "sweetalert2";
import {useNavigate} from "react-router-dom";

function BookingPage({ setLoading, loading }) {
  const { vehicleId } = useParams();
  const navigate = useNavigate();
  const [vehicle, setVehicle] = useState({});
  const [bookedDates, setBookedDates] = useState([]);
  const [showToast, setShowToast] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [user, setUser] = useState(null);
  const [vehicleOwner, setVehicleOwner] = useState({});

  useEffect(() => {
    setLoading(true);
    api
      .get("/users/checklogin", { withCredentials: true })
      .then((response) => {
        setUser(response.data.user.user);
        setIsLoggedIn(true);
      })
      .catch(() => setUser(null));
    setLoading(false);
  }, []);

  useEffect(() => {
    setLoading(true);
    api
      .post("/vehicles/getvehiclebyid", { vehicleId })
      .then((response) => {
        setVehicle(response.data.vehicle);
      })
      .catch((error) => console.log(error));
    setLoading(false);
    setLoading(true);
    // Fetch booked dates
    api
      .post("/vehicles/getbookeddates", { vehicleId }) // Ensure this API exists
      .then((response) => {
        setBookedDates(response.data.bookedDates);
      })
      .catch((error) => console.log(error));
    setLoading(false);
  }, [vehicleId]);

  useEffect(() => {
    
    const fetchOwner = async () => {
      setLoading(true);
      if (vehicle && vehicle.userId) {
        try {
          const ownerResponse = await api.post("/users/getUserById", {
            userId: vehicle.userId,
          });
          
          setVehicleOwner(ownerResponse.data.user);
          console.log(ownerResponse.data.user);
        } catch (error) {
          console.error("Error fetching vehicle owner:", error);
        }
      }
      setLoading(false);
    };
  
    fetchOwner();
  }, [vehicle]);

  const isLoadVehicle = vehicle.type === "Lorry" || vehicle.type === "Pickup";
  const [selectedDate, setSelectedDate] = useState(null);
  const [hourlyBookings, setHourlyBookings] = useState([]);

  const handleDayClick = (date) => {
    if (!isLoadVehicle) return;
    const dateStr = format(date, "yyyy-MM-dd");
    setSelectedDate(dateStr);
    api
      .post("/bookings/getHourlyBookings", { vehicleId, date: dateStr })
      .then((res) => setHourlyBookings(res.data.bookings || []))
      .catch(() => setHourlyBookings([]));
  };

  // Returns the status of a 1-hour slot starting at `hour` (6–21)
  const getSlotStatus = (hour) => {
    const slotStart = `${String(hour).padStart(2, "0")}:00`;
    const slotEnd = `${String(hour + 1).padStart(2, "0")}:00`;
    for (const b of hourlyBookings) {
      if (!b.isHourly) return "fullday";
      if (b.startTime < slotEnd && b.endTime > slotStart) {
        return b.isAccepted === "accepted" ? "accepted" : "pending";
      }
    }
    return "available";
  };

  const SLOT_HOURS = Array.from({ length: 16 }, (_, i) => i + 6); // 6 AM–9 PM (each = 1-hour slot ending at next hour)

  const images = (vehicle.imageURLs || []).filter(url => url !== null);

  const [currentIndex, setCurrentIndex] = useState(0);

  const prevSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  const nextSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === images.length - 1 ? 0 : prevIndex + 1
    );
  };

  const tileClassName = ({ date }) => {
    const formattedDate = format(date, "yyyy-MM-dd");
    const isBooked = bookedDates.includes(formattedDate);
    const isSelected = isLoadVehicle && selectedDate === formattedDate;
    // Lorry/Pickup tiles are clickable to show hourly timeline
    const pointerClass = isLoadVehicle ? "cursor-pointer" : "pointer-events-none";
    return [isBooked ? "relative" : "", isSelected ? "!bg-[#6f48e5]/10 !rounded-lg" : "", pointerClass].join(" ").trim();
  };

  const tileContent = ({ date }) => {
    const formattedDate = format(date, "yyyy-MM-dd");
    const isBooked = bookedDates.includes(formattedDate);

    return isBooked ? (
      <span className="absolute  w-2.5 h-2.5 rounded-full bg-[#6F48E5]"></span>
    ) : null;
  };

  const [fanRating, setFanRating] = useState(0);
  const [customerRating, setCustomerRating] = useState(0);

  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleReserve = () => {
    if (!isLoggedIn) {
      Swal.fire({
                icon: 'warning',
                title: 'Please login to continue',
                text: 'You need to be logged in to reserve a vehicle',
              });
              navigate('/signIn');
      return;
    }else{
    setIsModalOpen(true);
    }
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  if (loading) {
    return null;
  }

  return (
    <>
      <style>
        {`
          .react-calendar__tile--now {
            background: none !important;
            border: none !important;
            box-shadow: none !important;
          }
             .react-calendar {
            border: none !important;
          }
          
        `}
      </style>
      {isModalOpen && (
        <BookingModal
          isOpen={isModalOpen}
          onClose={handleCloseModal}
          vehicleId={vehicleId}
          user={user}
          vehicle={vehicle}
        />
      )}
      {showToast && (
        <div
          className="flex items-center w-full max-w-xs p-4 bg-white text-gray-700 rounded-lg shadow-md fixed top-4 left-1/2 transform -translate-x-1/2 z-50 animate-fadeIn"
          role="alert"
        >
          <div className="inline-flex items-center justify-center flex-shrink-0 w-8 h-8 rounded-lg bg-[#6f48e5] text-white">
            <svg
              className="w-5 h-5"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              viewBox="0 0 22 20"
            >
              <path d="M20.924 7.625a1.523 1.523 0 0 0-1.238-1.044l-5.051-.734-2.259-4.577a1.534 1.534 0 0 0-2.752 0L7.365 5.847l-5.051.734A1.535 1.535 0 0 0 1.463 9.2l3.656 3.563-.863 5.031a1.532 1.532 0 0 0 2.226 1.616L11 17.033l4.518 2.375a1.534 1.534 0 0 0 2.226-1.617l-.863-5.03L20.537 9.2a1.523 1.523 0 0 0 .387-1.575Z" />
            </svg>
          </div>
          <div className="ml-3">
            <p className="text-sm font-semibold">Thank You!</p>
            <p className="text-xs text-gray-500">
              Your Feedback is very important to us.
            </p>
          </div>
          <button
            type="button"
            className="ml-auto -mx-1.5 -my-1.5 bg-white text-gray-400 hover:text-gray-900 hover:bg-gray-100 rounded-lg p-1.5 inline-flex items-center justify-center h-8 w-8 focus:ring-2 focus:ring-[#6f48e5]/40"
            onClick={() => setShowToast(false)}
            aria-label="Close"
          >
            <span className="sr-only">Close</span>
            <svg
              className="w-3 h-3"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 14 14"
            >
              <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
              />
            </svg>
          </button>
        </div>
      )}
      <div className="flex flex-row justify-center mx-5 lg:mx-10">
        <div className="relative w-full max-w-4xl overflow-hidden rounded-lg shadow-lg mt-10">
          <div className="relative w-full aspect-[16/9]">
            {images.map((img, index) => (
              <img
                key={index}
                src={img}
                className={`absolute w-full h-full object-cover transition-opacity duration-700 ${
                  index === currentIndex ? "opacity-100" : "opacity-0"
                }`}
                alt={`Slide ${index + 1}`}
              />
            ))}
          </div>

          {/* Navigation Buttons */}
          <button
            onClick={prevSlide}
            className="absolute top-1/2 left-2 transform -translate-y-1/2 bg-gray-800/50 text-white p-2 rounded-full hover:bg-gray-800/70"
          >
            &#10094;
          </button>
          <button
            onClick={nextSlide}
            className="absolute top-1/2 right-2 transform -translate-y-1/2 bg-gray-800/50 text-white p-2 rounded-full hover:bg-gray-800/70"
          >
            &#10095;
          </button>

          {/* Indicators */}
          <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex space-x-2">
            {images.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentIndex(index)}
                className={`w-3 h-3 rounded-full ${
                  index === currentIndex ? "bg-white" : "bg-gray-500"
                }`}
              ></button>
            ))}
          </div>
        </div>
      </div>

      <div className="flex flex-row sm:justify-center sm:mt-0 -mt-15">
        <div className="flex w-full flex-col sm:flex-row justify-center lg:mx-10 lg:mt-5 sm:gap-2 lg:w-[56rem] md:w-[48rem] max-w-4xl">
          <div className="sm:w-1/2 flex rounded-lg scale-90 sm:scale-75 md:scale-90  lg:scale-100 flex-col sm:flex-row">
            <div className="bg-white p-6 shadow-2xl rounded-lg">
              <h2 className="text-xl font-semibold text-gray-800 mb-4">
                Booked Calendar
              </h2>
              <Calendar
                className="rounded-lg"
                tileClassName={tileClassName}
                tileContent={tileContent}
                onClickDay={isLoadVehicle ? handleDayClick : undefined}
              />
              {isLoadVehicle && !selectedDate && (
                <p className="mt-3 text-xs text-gray-400 text-center">
                  Tap a date to see hourly availability
                </p>
              )}
              {/* Hourly availability timeline (Lorry/Pickup) */}
              {isLoadVehicle && selectedDate && (
                <div className="mt-4">
                  <p className="text-sm font-semibold text-gray-700 mb-2">
                    Hourly slots — {selectedDate}
                  </p>
                  <div className="grid grid-cols-4 gap-1">
                    {SLOT_HOURS.map((hour) => {
                      const status = getSlotStatus(hour);
                      const startH = hour;
                      const endH = hour + 1;
                      const fmt = (h) =>
                        h < 12 ? `${h}AM` : h === 12 ? "12PM" : `${h - 12}PM`;
                      const colors = {
                        available: "bg-green-50 text-green-700 border-green-200",
                        pending: "bg-yellow-50 text-yellow-700 border-yellow-200",
                        accepted: "bg-red-50 text-red-600 border-red-200",
                        fullday: "bg-red-100 text-red-700 border-red-300",
                      };
                      return (
                        <div
                          key={hour}
                          className={`text-[10px] text-center py-1 rounded border ${colors[status]}`}
                        >
                          {fmt(startH)}–{fmt(endH)}
                        </div>
                      );
                    })}
                  </div>
                  <div className="flex gap-3 mt-2 text-[10px] text-gray-500">
                    <span className="flex items-center gap-1">
                      <span className="w-2 h-2 rounded-full bg-green-400 inline-block" />Free
                    </span>
                    <span className="flex items-center gap-1">
                      <span className="w-2 h-2 rounded-full bg-yellow-400 inline-block" />Pending
                    </span>
                    <span className="flex items-center gap-1">
                      <span className="w-2 h-2 rounded-full bg-red-400 inline-block" />Booked
                    </span>
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className="sm:w-1/2 bg-white shadow-2xl rounded-lg flex flex-col items-stretch scale-90 sm:scale-75 md:scale-90 lg:scale-100">
            {/* For Buttons */}
            <div className="border boder-gray w-full rounded-t-lg h-1/2 flex flex-col items-center justify-center p-6 sm:gap-0 gap-5">
              <div className="h-1/3 w-full text-justify">
                For Rent by <b>{vehicleOwner.firstName} {vehicleOwner.lastName}</b>{" "}
              </div>
              <div className="h-1/3 w-full flex flex-row justify-start space-x-2">
                <FaPhone size={25} className="text-[#6F48E5]" />
                <p>{vehicleOwner.phoneNumber}</p>
              </div>
              <div className="h-1/3 w-full flex flex-row justify-start space-x-2">
                <MdEmail size={30} className="text-[#6F48E5]" />
                <p>{vehicleOwner.email}</p>
              </div>
            </div>
            <div className="border border-gray rounded-b-lg h-1/2 p-5">
              <button
                className="bg-[#6F48E5] w-full h-1/2 rounded-lg text-xl font-bold hover:bg-[#A9B9E3] text-[#EFF1F3] transition-all duration-700"
                onClick={handleReserve}
              >
                Reserve Now
              </button>

              {/* --------------------------------------------------------------------------- */}
              <div className="space-y-6">
                <div className=" flex flex-row justify-between mt-5">
                  <Ratings
                    ratingType="Fan"
                    rating={fanRating}
                    setRating={setFanRating}
                    setVehicle={setVehicle}
                    vehicle={vehicle}
                    setShowToast={setShowToast}
                    isLoggedIn = {isLoggedIn}
                  />
                  <Ratings
                    ratingType="Customer"
                    rating={customerRating}
                    setRating={setCustomerRating}
                    setVehicle={setVehicle}
                    vehicle={vehicle}
                    setShowToast={setShowToast}
                    isLoggedIn = {isLoggedIn}
                    userId={user?._id}
                  />
                </div>
              </div>
              {/* --------------------------------------------------------------------------- */}
            </div>
          </div>
        </div>
      </div>
      <div className="flex flex-row justify-center mt-5 mx-5">
        <VehicleDescription vehicle={vehicle} />
      </div>
    </>
  );
}

export default BookingPage;
